// 存放校验函数
import { httpPostIsAnonymous } from "@/api/httpService";
import { ElMessage } from "element-plus";
import { remindErrorMessage } from "@/utils/utils";

/**验证用户名格式 */
const checkLoginName = function (name) {
  // 使用正则表达式检查字符串是否包含除字母、数字、汉字或下划线之外的特殊字符
  var reg = /[^a-zA-Z0-9_\u4e00-\u9fa5]/; //正则表达式
  if (!reg.test(name)) {
    //正则验证通过，格式正确
    return true;
  } else {
    return false;
  }
};
/**验证用户名第一个字符 */
const checkLoginNameFirstChar = function (name) {
  var reg = /^[0-9_]/; //正则表达式
  if (!reg.test(name[0])) {
    //正则验证通过，格式正确
    return true;
  } else {
    return false;
  }
};
/**验证用户名长度 */
const checkLoginNameLength = function (name) {
  // 使用正则表达式将汉字替换为两个字符
  const stringWithDoubleChineseChars = name.replace(/[\u4e00-\u9fa5]/g, "12");
  if (
    stringWithDoubleChineseChars.length >= 6 &&
    stringWithDoubleChineseChars.length <= 20
  ) {
    return true;
  } else {
    return false;
  }
};

/**验证手机号格式 */
const checkPhone = function (phone) {
  // 以1开头的11位数字
  var reg = /^1[3-9][0-9]{9}$/;
  if (phone.length == 11 && reg.test(phone)) {
    return true;
  } else {
    return false;
  }
};

/**验证邮箱格式 */
const checkEmail = function (email) {
  var reg = new RegExp(
    "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
  ); //正则表达式
  if (reg.test(email)) {
    //正则验证通过，格式正确
    return true;
  } else {
    return false;
  }
};

/**验证密码格式 */
const checkPassword = function (password) {
  // 定义三个正则表达式，分别用于匹配字母、数字和特殊符号
  var letterRegex = /[a-zA-Z]/;
  var digitRegex = /[0-9]/;
  var specialCharRegex = /[\s~`!@#$%^&*()\-_=+[\]{}|;:'",<.>/?]/;
  // 计数器，用于记录满足条件的字符类别数量
  var count = 0;
  // 检查字符串中是否包含字母、数字和特殊符号中的两种或更多
  if (letterRegex.test(password)) {
    count++;
  }
  if (digitRegex.test(password)) {
    count++;
  }
  if (specialCharRegex.test(password)) {
    count++;
  }
  // 检查计数器是否大于等于2
  if (count >= 2) {
    return true; // 字符串包含了至少两种字符类别
  } else {
    return false; // 字符串不满足要求
  }
};

/**校验手机号/邮箱是否有效*/
const checkPhoneOrEmailValid = async (account) => {
  let params = {
    account: account.trim(),
  };
  let res = await httpPostIsAnonymous(
    "/identity/v1/checkPhoneOrEmailValid",
    params
  );
  if (res.code === 0) {
    // if (!res.data.ifRegister) {
    //   ElMessage.warning("该手机号/邮箱尚未注册");
    //   return false;
    // } else if (res.data.ifDisabled) {
    //   ElMessage.warning("该手机号/邮箱已被禁用");
    //   return false;
    // } else if (res.data.ifRegister && !res.data.ifDisabled) {
    //   return true;
    // }
    return {
      ifNotRegister: !res.data.ifRegister,
      ifDisabled: res.data.ifDisabled,
    };
  }
};

/**校验验证码是否正确*/
const checkCodeValid = async (account, code) => {
  let params = {
    account: account,
    code: code,
  };
  let res = await httpPostIsAnonymous("/identity/v1/checkCodeIfValid", params);
  if (res.code === 0) {
    if (res.data) {
      return true;
    } else {
      ElMessage.warning("验证码错误");
      return false;
    }
  } else {
    remindErrorMessage(res.message);
    return false;
  }
};

export {
  checkLoginName,
  checkLoginNameFirstChar,
  checkLoginNameLength,
  checkPassword,
  checkPhone,
  checkEmail,
  checkPhoneOrEmailValid,
  checkCodeValid,
};
